import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export const useAuth = () => {
  const [session, setSession] = useState(undefined);
  const [authError, setAuthError] = useState(null);

  // Detect OAuth callback errors in the URL (GoTrue sends ?error=... query params)
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const error = searchParams.get('error_description') || searchParams.get('error');
    if (error) {
      setAuthError(decodeURIComponent(error));
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  // Session listener
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => setSession(data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => setSession(s));
    return () => sub.subscription.unsubscribe();
  }, []);

  // Sign out locally before starting a new OAuth flow — prevents
  // the old session from persisting through a failed callback.
  const signIn = useCallback(async () => {
    setAuthError(null);
    await supabase.auth.signOut({ scope: 'local' });
    await supabase.auth.signInWithOAuth({ provider: 'google' });
  }, []);

  const signInWithX = useCallback(async () => {
    setAuthError(null);
    await supabase.auth.signOut({ scope: 'local' });
    await supabase.auth.signInWithOAuth({ provider: 'x' });
  }, []);

  const signOut = useCallback(() => supabase.auth.signOut(), []);
  const clearAuthError = useCallback(() => setAuthError(null), []);

  return {
    session,
    user: session?.user ?? null,
    loading: session === undefined,
    authError,
    clearAuthError,
    signIn,
    signInWithX,
    signOut,
  };
};
